(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apps"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('coverly-deferred-reviews')) {
    customElements.define('coverly-deferred-reviews', class extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('template[data-coverly-review-content]');
        if (!this.content || this.started) return;
        this.started = true;
        this.isReviewHash = hash => hash === '#looxReviews' || hash === '#looxReviewsFrame';
        this.onHash = () => {
          if (this.isReviewHash(location.hash)) this.reveal(true);
        };
        this.onLink = event => {
          const link = event.target.closest?.('a[href]');
          if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const url = new URL(link.href, location.href);
          if (url.origin === location.origin && url.pathname === location.pathname && this.isReviewHash(url.hash)) this.reveal(url.hash === '#looxReviewsFrame');
        };
        document.addEventListener('click', this.onLink, true);
        window.addEventListener('hashchange', this.onHash);
        if (this.isReviewHash(location.hash)) this.reveal(true);
        else if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) this.reveal();
          }, { rootMargin: '800px 0px' });
          this.observer.observe(this);
        } else this.reveal();
      }
      reveal(scroll = false) {
        if (!this.content) return;
        const content = this.content;
        this.content = null;
        this.replaceChildren(content.content.cloneNode(true));
        this.dataset.loaded = 'true';
        this.observer?.disconnect();
        if (scroll) requestAnimationFrame(() => this.scrollIntoView({ block: 'start' }));
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        document.removeEventListener('click', this.onLink, true);
        window.removeEventListener('hashchange', this.onHash);
        this.started = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coverly-component-explorer"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('coverly-component-explorer'))customElements.define('coverly-component-explorer',class extends HTMLElement{
 connectedCallback(){
  if(this.abort)return;this.abort=new AbortController();const signal=this.abort.signal;
  this.dialog=this.querySelector('dialog');this.host=this.querySelector('[data-viewer-host]');this.loading=this.querySelector('.cce-loading');this.fallback=this.querySelector('[data-fallback]');
  this.querySelectorAll('[data-launch]').forEach(button=>button.addEventListener('click',()=>this.open(button),{signal}));
  this.querySelectorAll('[data-frame-family-choice]').forEach(button=>button.addEventListener('click',()=>{
   this.dataset.frameFamily=button.dataset.frameFamilyChoice;
   this.querySelectorAll('[data-frame-family-choice]').forEach(choice=>choice.setAttribute('aria-pressed',String(choice===button)));
  },{signal}));
  this.querySelector('[data-close]').addEventListener('click',()=>this.dialog.close(),{signal});
  this.dialog.addEventListener('close',()=>this.cleanup(),{signal});
  window.addEventListener('message',event=>{
   if(!this.frame||event.source!==this.frame.contentWindow||event.origin!==this.viewerOrigin)return;
   if(event.data?.type==='coverly:component-close')this.dialog.close();
   if(event.data?.type==='coverly:component-ready'){this.loading.hidden=true;clearTimeout(this.timer);}
   if(event.data?.type==='coverly:frame-guide-state'&&event.data.guide===this.dataset.frameGuide&&['hybrid','wood'].includes(event.data.family)){
    const choices=[...this.querySelectorAll('[data-frame-family-choice]')];
    if(choices.some(choice=>choice.dataset.frameFamilyChoice===event.data.family)){
     this.dataset.frameFamily=event.data.family;
     choices.forEach(choice=>choice.setAttribute('aria-pressed',String(choice.dataset.frameFamilyChoice===event.data.family)));
    }
   }
  },{signal});
 }
 open(button){
  if(this.dialog.open)return;this.opener=button;
  this.querySelector('.cce-error').hidden=true;this.loading.hidden=false;this.fallback.hidden=true;this.querySelector('.cce-spinner').hidden=false;
  this.dialog.showModal();this.previousOverflow=document.body.style.overflow;document.body.style.overflow='hidden';
  let url;try{url=new URL(this.dataset.url);if(url.protocol!=='https:'&&!(url.protocol==='http:'&&['127.0.0.1','localhost'].includes(url.hostname)))throw Error('Invalid viewer URL');}catch{this.loading.hidden=true;this.querySelector('.cce-error').hidden=false;return;}
  url.searchParams.set('profile',this.dataset.profile);url.searchParams.set('embed','1');url.searchParams.set('parentOrigin',location.origin);
  if(button.dataset.part)url.searchParams.set('part',button.dataset.part);else url.searchParams.delete('part');
  if(this.dataset.frameGuide){
   url.searchParams.set('frameGuide',this.dataset.frameGuide);url.searchParams.set('frameFamily',this.dataset.frameFamily);url.searchParams.set('part','frame');
   url.searchParams.set('profile',this.dataset.frameFamily==='wood'?'shutter-painted-wood':'shutter-hybrid');
  }else{url.searchParams.delete('frameGuide');url.searchParams.delete('frameFamily');}
  if(this.dataset.catalog)url.searchParams.set('catalog',this.dataset.catalog);else url.searchParams.delete('catalog');
  this.viewerOrigin=url.origin;this.fallback.href=url.href;
  // No iframe or renderer requests exist before this click.
  this.frame=document.createElement('iframe');this.frame.title=this.querySelector('.cce-dialog-header h2').textContent;this.frame.allow='fullscreen';this.frame.referrerPolicy='strict-origin-when-cross-origin';this.frame.src=url.href;this.host.append(this.frame);
  this.timer=setTimeout(()=>{if(this.loading.hidden)return;this.fallback.hidden=false;this.querySelector('.cce-spinner').hidden=true;this.querySelector('.cce-error').hidden=false;},20000);
 }
 cleanup(){
  clearTimeout(this.timer);this.frame?.remove();this.frame=null;
  if(this.previousOverflow!==undefined){document.body.style.overflow=this.previousOverflow;this.previousOverflow=undefined;}
  if(this.opener?.isConnected)this.opener.focus();
 }
 disconnectedCallback(){this.dialog?.close();this.cleanup();this.abort?.abort();this.abort=null;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coverly-footer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('coverly-footer-slideshow')) {
  customElements.define('coverly-footer-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.slides = [...this.querySelectorAll('.cf-slide')];
      this.index = Math.max(0, this.slides.findIndex(slide => slide.hasAttribute('data-active')));
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
      this.inView = false;
      this.editorSelected = false;
      this.focused = false;
      this.hovered = false;
      if (this.slides.length < 2) return;
      this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); this.schedule(); }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => { this.paused = this.dataset.autoplay !== 'true' || this.motion.matches; this.schedule(); }, options);
      this.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.slideId === event.detail.blockId);
        if (index < 0) return;
        this.editorSelected = true;
        this.show(index);
        this.schedule();
      }, options);
      this.addEventListener('shopify:block:deselect', () => { this.editorSelected = false; this.schedule(); }, options);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        if (this.inView) this.querySelectorAll('img').forEach(img => { img.loading = 'eager'; });
        this.schedule();
      });
      this.observer.observe(this);
    }
    show(index) {
      this.slides.forEach((slide, i) => slide.toggleAttribute('data-active', i === index));
      this.index = index;
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.paused || !this.inView || document.hidden || this.focused || this.hovered || this.editorSelected || this.slides.length < 2) return;
      this.timer = setTimeout(() => {
        const next = (this.index + 1) % this.slides.length;
        const img = this.slides[next].querySelector('img');
        if (!img || (img.complete && img.naturalWidth > 0)) this.show(next);
        this.schedule();
      }, Number(this.dataset.duration) || 5000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}
if (!customElements.get('coverly-footer-signup')) {
  customElements.define('coverly-footer-signup', class extends HTMLElement {
    connectedCallback() {
      this.listeners?.abort();
      this.listeners = new AbortController();
      this.form = this.querySelector('form');
      this.email = this.querySelector('input[type="email"]');
      this.button = this.querySelector('button[type="submit"]');
      this.status = this.querySelector('.cf-crm-status');
      this.code = this.querySelector('.cf-crm-code');
      if (!this.form || !this.email || !this.button || !this.status) return;
      this.email.disabled = false;
      this.button.disabled = this.form.dataset.submitted === 'true';
      this.email.readOnly = this.form.dataset.submitted === 'true';
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        if (this.pending || this.form.dataset.submitted === 'true' || !this.form.reportValidity()) return;
        this.submit();
      }, { signal: this.listeners.signal });
    }
    connection() {
      const script = [...document.querySelectorAll('script[data-site]')].find(node => {
        try { return new URL(node.src, location.href).pathname.endsWith('/popup/p.js'); } catch { return false; }
      });
      const configUrl = this.dataset.configUrl?.trim() ? new URL(this.dataset.configUrl, location.href) : null;
      if (configUrl && !configUrl.pathname.endsWith('/api/popup/config')) throw new Error('Invalid CRM connection URL');
      const siteKey = configUrl ? configUrl.searchParams.get('site') : script?.getAttribute('data-site') || '';
      const configured = configUrl ? configUrl.origin + configUrl.pathname.slice(0, -17) : script?.getAttribute('data-base');
      const base = configured ? new URL(configured, location.href) : script ? new URL(new URL(script.src, location.href).origin) : null;
      if (configUrl && (configUrl.username || configUrl.password)) throw new Error('Invalid CRM connection URL');
      if (!siteKey || !base || base.protocol !== 'https:' || base.username || base.password) throw new Error('Missing CRM connection');
      base.search = '';
      base.hash = '';
      return { siteKey, apiBase: base.href.replace(/\/+$/, '') };
    }
    async request(url, options = {}) {
      const response = await fetch(url, { ...options, credentials: 'omit', signal: this.requestController.signal });
      const data = await response.json();
      if (!response.ok || !data || typeof data !== 'object') throw new Error('Signup request failed');
      return data;
    }
    async submit() {
      this.pending = true;
      this.button.disabled = true;
      this.email.readOnly = true;
      this.form.setAttribute('aria-busy', 'true');
      this.status.hidden = false;
      this.status.textContent = this.dataset.busy;
      this.status.setAttribute('role', 'status');
      this.email.setAttribute('aria-describedby', this.status.id);
      this.email.removeAttribute('aria-invalid');
      this.code.hidden = true;
      this.requestController = new AbortController();
      const timeout = setTimeout(() => this.requestController.abort(), 20000);
      try {
        const { siteKey, apiBase } = this.connection();
        const config = await this.request(`${apiBase}/api/popup/config?site=${encodeURIComponent(siteKey)}`);
        const campaign = Array.isArray(config.campaigns) ? config.campaigns.find(item => typeof item.id === 'string' && item.id) : null;
        if (!campaign) throw new Error('No active campaign');
        const utm = {};
        new URLSearchParams(location.search).forEach((value, key) => {
          if (/^utm_[a-z_]{1,40}$/i.test(key)) utm[key.toLowerCase()] = value.slice(0, 200);
        });
        const sessionId = this.sessionId || (this.sessionId = crypto.randomUUID());
        const data = await this.request(`${apiBase}/api/popup/lead`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            siteKey, campaignId: campaign.id, email: this.email.value.trim(),
            answers: { signup_source: 'footer' },
            context: {
              path: location.pathname.slice(0, 1000),
              pageUrl: (location.origin + location.pathname).slice(0, 1000),
              referrer: document.referrer.slice(0, 1000), utm,
              device: matchMedia('(max-width: 767px)').matches ? 'mobile' : 'desktop', sessionId
            }
          })
        });
        if (!Object.hasOwn(data, 'code') || !data.successCopy) throw new Error('Unexpected signup response');
        this.status.textContent = this.dataset.success;
        this.form.dataset.submitted = 'true';
        if (typeof data.code === 'string' && data.code) {
          this.code.textContent = `${this.dataset.codeLabel} ${data.code}`;
          this.code.hidden = false;
        }
        this.dispatchEvent(new CustomEvent('coverly:newsletter-subscribed', { bubbles: true, detail: { source: 'footer' } }));
      } catch {
        if (this.isConnected) {
          this.status.textContent = this.dataset.error;
          this.status.setAttribute('role', 'alert');
          this.email.readOnly = false;
          this.button.disabled = false;
        }
      } finally {
        clearTimeout(timeout);
        this.pending = false;
        this.form.removeAttribute('aria-busy');
      }
    }
    disconnectedCallback() {
      this.listeners?.abort();
      this.requestController?.abort();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coverly-home-heroes"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('coverly-hero-slideshow'))customElements.define('coverly-hero-slideshow',class extends HTMLElement{
 connectedCallback(){queueMicrotask(()=>{if(this.isConnected)this.initialize()})}
 initialize(){
  this.slides=[...this.querySelectorAll('[data-slide]')];this.buttons=[...this.querySelectorAll('[data-go]')];
  this.abort=new AbortController();const on=(el,event,fn)=>el.addEventListener(event,e=>{fn(e);this.syncAnimation?.()},{signal:this.abort.signal});
  const sizeHero=()=>{const top=Math.max(0,this.getBoundingClientRect().top+window.scrollY);this.style.setProperty('--hero-top-offset',`${top}px`)};
  sizeHero();on(window,'resize',sizeHero);on(window,'load',sizeHero);
  this.headerObserver=new ResizeObserver(sizeHero);document.querySelectorAll('.shopify-section-group-header-group').forEach(el=>this.headerObserver.observe(el));
  if(this.slides.length<2)return;
  this.fills=this.buttons.map(b=>b.querySelector('.chs-fill'));this.index=0;this.elapsed=0;this.last=0;this.duration=Number(this.dataset.duration)||6000;this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.paused=this.motion.matches;this.hover=false;this.focus=false;this.visible=true;
  this.querySelector('[data-controls]').hidden=false;
  this.buttons.forEach((b,i)=>on(b,'click',()=>this.show(i)));

  on(this,'pointerenter',e=>{if(e.pointerType==='mouse')this.hover=true});on(this,'pointerleave',()=>this.hover=false);
  on(this,'focusin',()=>this.focus=true);on(this,'focusout',e=>this.focus=this.contains(e.relatedTarget));
  on(this,'pointerdown',e=>{this.startX=e.clientX;this.startY=e.clientY});on(this,'pointerup',e=>{const x=e.clientX-this.startX,y=e.clientY-this.startY;if(Math.abs(x)>60&&Math.abs(x)>Math.abs(y)*1.5)this.show(this.index+(x<0?1:-1))});
  on(this,'keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.show(this.index+(e.key==='ArrowRight'?1:-1))}});
  on(document,'visibilitychange',()=>this.last=0);on(this.motion,'change',()=>{this.paused=this.motion.matches});
  on(document,'shopify:block:select',e=>{const i=this.slides.findIndex(s=>s.dataset.blockId===e.detail.blockId);if(i>=0){this.show(i);this.paused=true}});
  on(document,'shopify:block:deselect',()=>{this.paused=this.motion.matches});
  this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.syncAnimation()});this.observer.observe(this);
  this.canAnimate=()=>!this.paused&&!this.hover&&!this.focus&&!document.hidden&&this.visible;
  this.syncAnimation=()=>{if(this.canAnimate()){if(!this.raf){this.last=0;this.raf=requestAnimationFrame(this.tick)}}else{cancelAnimationFrame(this.raf);this.raf=0;this.last=0}};
  this.tick=time=>{this.raf=0;if(!this.canAnimate()){this.last=0;return}if(this.last){this.elapsed+=time-this.last;if(this.elapsed>=this.duration)this.show(this.index+1);this.fills[this.index].style.transform=`scaleX(${this.elapsed/this.duration})`}this.last=time;this.raf=requestAnimationFrame(this.tick)};this.paint();this.syncAnimation();
 }

 paint(){this.buttons.forEach((b,i)=>b.querySelector('.chs-fill').style.transform=`scaleX(${i===this.index?this.elapsed/this.duration:0})`)}
 show(i){this.index=(i+this.slides.length)%this.slides.length;this.elapsed=0;this.last=0;this.slides.forEach((s,n)=>{s.hidden=n!==this.index;s.inert=n!==this.index;s.classList.toggle('is-active',n===this.index)});this.buttons.forEach((b,n)=>{if(n===this.index)b.setAttribute('aria-current','true');else b.removeAttribute('aria-current')});this.paint()}
 disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.headerObserver?.disconnect();cancelAnimationFrame(this.raf)}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coverly-motor-connections"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('coverly-motor-connections')) {
  customElements.define('coverly-motor-connections', class extends HTMLElement {
    connectedCallback() {
      this.lifecycle?.abort();
      this.lifecycle = new AbortController();
      this.readyFrame = requestAnimationFrame(() => {
        if (!this.isConnected) return;
        this.picker = this.querySelector('[data-cmn-picker]');
        this.summary = this.picker?.querySelector('summary');
        this.selection = this.querySelector('[data-cmn-selection]');
        this.empty = this.querySelector('[data-cmn-empty]');
        this.inputs = [...this.querySelectorAll('[data-cmn-toggle]')];
        this.rows = [...this.querySelectorAll('[data-cmn-row]')];
        if (!this.picker || !this.selection || !this.empty) return;
        const options = { signal: this.lifecycle.signal };
        this.addEventListener('change', (event) => {
          if (event.target.matches('[data-cmn-toggle]')) this.refresh();
        }, options);
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.picker.open) {
            event.preventDefault();
            this.picker.open = false;
            this.summary.focus();
          }
        }, options);
        this.picker.addEventListener('focusout', (event) => {
          if (event.relatedTarget && !this.picker.contains(event.relatedTarget)) this.picker.open = false;
        }, options);
        document.addEventListener('pointerdown', (event) => {
          if (this.picker.open && !this.picker.contains(event.target)) this.picker.open = false;
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const row = event.target.closest('[data-cmn-row]');
          if (!row || !this.contains(row)) return;
          const input = this.inputs.find((item) => item.value === row.dataset.cmnRow);
          if (input) {
            input.checked = true;
            this.refresh();
            row.scrollIntoView({ block: 'nearest' });
          }
        }, options);
        this.refresh();
      });
    }

    refresh() {
      const selected = this.inputs.filter((input) => input.checked);
      const ids = new Set(selected.map((input) => input.value));
      this.rows.forEach((row) => { row.hidden = !ids.has(row.dataset.cmnRow); });
      this.selection.textContent = selected.length
        ? selected.map((input) => input.dataset.cmnLabel).join(', ')
        : this.dataset.cmnEmptyLabel;
      this.empty.hidden = selected.length > 0;
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.readyFrame);
      this.lifecycle?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coverly-review-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('coverly-review-gallery')) {
  customElements.define('coverly-review-gallery', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => { if (this.isConnected && !this.abort) this.init(); });
    }
    init() {
      this.abort = new AbortController();
      this.grid = this.querySelector('.crg-grid');
      this.columns = [...this.querySelectorAll('[data-crg-column]')];
      this.tiles = [...this.querySelectorAll('[data-crg-tile]')];
      this.media = matchMedia('(max-width:989px)');
      this.media.addEventListener('change', () => this.layout(), {signal:this.abort.signal});
      this.layout();
    }
    layout() {
      const mobile = this.media.matches;
      const order = tile => mobile && Number(tile.dataset.mobileOrder) > 0 ? Number(tile.dataset.mobileOrder) : Number(tile.dataset.order);
      const tiles = [...this.tiles].sort((a,b) => order(a) - order(b) || Number(a.dataset.order) - Number(b.dataset.order));
      for (const tile of tiles) {
        const target = Number(mobile ? tile.dataset.mobileColumn : tile.dataset.desktopColumn) || 1;
        this.columns[Math.max(0, Math.min((mobile ? 2 : 4) - 1, target - 1))].append(tile);
      }
      this.columns.forEach(column => { column.hidden = !column.children.length; });
      this.grid.style.setProperty('--crg-columns', Math.max(1, this.columns.filter(column => !column.hidden).length));
      this.setAttribute('data-crg-ready','');
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coverly-shade-us-them"] && !Shopify.designMode) return;
  try {
    
(() => {
  class CoverlyShadeVersus extends HTMLElement {
    connectedCallback() { this.frame = requestAnimationFrame(() => this.init()); }
    disconnectedCallback() { cancelAnimationFrame(this.frame); this.abort?.abort(); this.observer?.disconnect(); this.video?.pause(); }
    init() {
      this.abort?.abort(); this.observer?.disconnect(); this.abort = new AbortController();
      const signal = this.abort.signal;
      this.video = this.querySelector('video'); this.button = this.querySelector('[data-versus-playback]');
      if (!this.video || !this.button) return;
      this.video.muted = true; this.video.defaultMuted = true;
      this.mediaQuery = matchMedia('(prefers-reduced-motion: reduce)');
      this.wantsPlayback = this.dataset.autoplay === 'true' && !this.mediaQuery.matches;
      this.inView = false; this.button.hidden = false;
      const showState = () => {
        const playing = !this.video.paused && !this.video.ended;
        this.video.classList.toggle('is-playing', playing);
        this.button.querySelector('[data-playback-label]').textContent = playing ? this.button.dataset.pauseLabel : this.button.dataset.playLabel;
        this.button.querySelector('[data-play-icon]').toggleAttribute('hidden', playing);
        this.button.querySelector('[data-pause-icon]').toggleAttribute('hidden', !playing);
      };
      this.updatePlayback = () => {
        if (!this.isConnected || !this.wantsPlayback || !this.inView || document.hidden) { this.video.pause(); return; }
        if (this.video.paused) this.video.play().then(() => {
          if (!this.isConnected || !this.wantsPlayback || !this.inView || document.hidden) this.video.pause();
          showState();
        }).catch(() => showState());
      };
      this.button.addEventListener('click', () => { this.wantsPlayback = this.video.paused; this.updatePlayback(); }, {signal});
      this.video.addEventListener('playing', showState, {signal});
      this.video.addEventListener('pause', showState, {signal});
      this.video.addEventListener('error', () => { this.video.pause(); showState(); this.button.hidden = true; }, {signal});
      this.mediaQuery.addEventListener('change', () => { if (this.mediaQuery.matches) this.wantsPlayback = false; this.updatePlayback(); }, {signal});
      document.addEventListener('visibilitychange', () => this.updatePlayback(), {signal});
      this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.updatePlayback(); }, {threshold:0});
      this.observer.observe(this); showState();
    }
  }
  if (!customElements.get('coverly-shade-us-them')) customElements.define('coverly-shade-us-them', CoverlyShadeVersus);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coverly-split-products"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('coverly-split-products')) {
  customElements.define('coverly-split-products', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => { if (this.isConnected) this.init(); });
    }
    init() {
      this.rail = this.querySelector('[data-rail]');
      this.items = [...this.querySelectorAll('[data-item]:not([data-clone])')];
      if (!this.rail || !this.items.length || this.abort) return;
      this.abort = new AbortController();
      this.index = 0;
      this.targetIndex = null;
      this.dots = [...this.querySelectorAll('[data-dot]')];
      const on = (el, type, fn) => el?.addEventListener(type, fn, { signal: this.abort.signal });
      this.items.forEach((item, index) => { item.dataset.productIndex = index; });
      if (this.items.length > 1) {
        const prefixClones = this.items.slice(-2).map(item => this.makeClone(item));
        const suffixClones = this.items.slice(0,2).map(item => this.makeClone(item));
        this.rail.prepend(...prefixClones);
        this.rail.append(...suffixClones);
        this.querySelectorAll('[data-prev],[data-next],[data-dots]').forEach(el => { el.hidden = false; });
      }
      this.slides = [...this.rail.children];
      on(this.querySelector('[data-prev]'), 'click', () => this.go((this.targetIndex ?? this.index) - 1));
      on(this.querySelector('[data-next]'), 'click', () => this.go((this.targetIndex ?? this.index) + 1));
      this.dots.forEach((button, index) => on(button, 'click', () => this.go(index)));
      on(this.rail, 'keydown', event => {
        let target;
        if (event.key === 'ArrowLeft') target = (this.targetIndex ?? this.index) - 1;
        if (event.key === 'ArrowRight') target = (this.targetIndex ?? this.index) + 1;
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = this.items.length - 1;
        if (target !== undefined) { event.preventDefault(); this.go(target); }
      });
      on(this.rail, 'scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
        this.queueSettle();
      });
      on(this.rail, 'scrollend', () => { if (!this.pointerDown) this.settle(); });
      on(this.rail, 'pointerdown', () => { this.pointerDown = true; });
      const release = () => { this.pointerDown = false; this.queueSettle(); };
      on(window, 'pointerup', release);
      on(window, 'pointercancel', release);
      this.resize = new ResizeObserver(() => {
        const width = this.rail.clientWidth;
        if (width !== this.lastWidth) {
          this.lastWidth = width;
          this.jump(this.targetIndex ?? this.index);
        }
        this.positionArrows();
      });
      this.resize.observe(this.rail);
      this.items.forEach(item => this.resize.observe(item.querySelector('.ccard__media')));
      this.content = new MutationObserver(records => {
        const changed = new Set(records.map(record => record.target.parentElement?.closest('[data-item]') || record.target.closest?.('[data-item]')));
        for (const item of changed) {
          if (!item || item.hasAttribute('data-clone')) continue;
          this.slides.filter(slide => slide.hasAttribute('data-clone') && slide.dataset.productIndex === item.dataset.productIndex).forEach(slide => {
            const fresh = this.makeClone(item);
            slide.replaceChildren(...fresh.childNodes);
          });
        }
      });
      this.items.forEach(item => this.content.observe(item.querySelector('.ccard'), { subtree: true, childList: true, attributes: true, attributeFilter: ['src','srcset','alt','href','aria-pressed','data-photo-missing'] }));
      this.setAttribute('data-loop-ready','');
      this.jump(0);
      on(document.fonts, 'loadingdone', () => this.positionArrows());
      document.fonts.ready.then(() => { if (this.isConnected) this.positionArrows(); });
    }
    makeClone(item) {
      const clone = item.cloneNode(true);
      clone.setAttribute('data-clone','');
      clone.setAttribute('aria-hidden','true');
      clone.inert = true;
      clone.querySelectorAll('script').forEach(el => el.remove());
      clone.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
      return clone;
    }
    offset(slide) {
      const box = slide.getBoundingClientRect(), rail = this.rail.getBoundingClientRect();
      return this.rail.scrollLeft + box.left + box.width / 2 - rail.left - this.rail.clientWidth / 2;
    }
    nearest() {
      return this.slides.reduce((best, slide) => Math.abs(this.offset(slide) - this.rail.scrollLeft) < Math.abs(this.offset(best) - this.rail.scrollLeft) ? slide : best, this.slides[0]);
    }
    update() {
      const active = this.nearest();
      this.index = Number(active.dataset.productIndex);
      this.slides.forEach(slide => {
        const selected = slide === active;
        slide.classList.toggle('is-active',selected);
        if (!slide.hasAttribute('data-clone')) {
          if (!selected && slide.contains(document.activeElement)) this.rail.focus({preventScroll:true});
          slide.inert = !selected;
          if (selected) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden','true');
        }
      });
      this.dots.forEach((dot,index) => {
        if (index === this.index) dot.setAttribute('aria-current','true');
        else dot.removeAttribute('aria-current');
      });
      this.positionArrows();
    }
    positionArrows() {
      const media = this.items[this.index]?.querySelector('.ccard__media');
      if (!media) return;
      const box = media.getBoundingClientRect(), viewport = this.querySelector('.csp-viewport').getBoundingClientRect();
      this.style.setProperty('--csp-image-center',`${box.top + box.height / 2 - viewport.top}px`);
    }
    jump(index) {
      if (!this.items?.length) return;
      this.index = (index + this.items.length) % this.items.length;
      this.targetIndex = null;
      this.rail.scrollTo({left:this.offset(this.items[this.index]),behavior:'instant'});
      this.update();
    }
    go(index) {
      const count = this.items.length;
      if (count < 2) return;
      if (this.targetIndex !== null) this.jump(this.targetIndex);
      const target = ((index % count) + count) % count;
      const matches = this.slides.filter(slide => Number(slide.dataset.productIndex) === target);
      const activeOffset = this.rail.scrollLeft;
      const direction = index < this.index ? -1 : 1;
      matches.sort((a,b) => {
        const da = this.offset(a) - activeOffset, db = this.offset(b) - activeOffset;
        const score = d => Math.abs(d) + (Math.sign(d) === direction ? 0 : 0.1);
        return score(da) - score(db);
      });
      this.targetIndex = target;
      this.rail.scrollTo({left:this.offset(matches[0]),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      this.queueSettle();
    }
    queueSettle() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => { if (!this.pointerDown) this.settle(); },150);
    }
    settle() {
      clearTimeout(this.timer);
      if (!this.isConnected) return;
      const active = this.nearest();
      const index = Number(active.dataset.productIndex);
      this.targetIndex = null;
      if (active.hasAttribute('data-clone')) this.jump(index);
      else this.update();
      const status = this.querySelector('[data-status]');
      if (status) status.textContent = this.items[index].querySelector('.ccard__title')?.textContent.trim() || '';
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.resize?.disconnect();
      this.content?.disconnect();
      cancelAnimationFrame(this.frame);
      clearTimeout(this.timer);
      this.querySelectorAll('[data-clone]').forEach(el => el.remove());
      this.items?.forEach(item => { item.inert = false; item.removeAttribute('aria-hidden'); item.classList.remove('is-active'); });
      this.removeAttribute('data-loop-ready');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coverly-stats-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('coverly-stats-banner')) {
    customElements.define('coverly-stats-banner', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        this.queueFit = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.fitText());
        };
        this.resizeObserver = new ResizeObserver(([entry]) => {
          if (entry.contentRect.width !== this.lastWidth) {
            this.lastWidth = entry.contentRect.width;
            this.queueFit();
          }
        });
        this.resizeObserver.observe(this);
        this.contentObserver = new MutationObserver(this.queueFit);
        this.contentObserver.observe(this, { childList: true, subtree: true, characterData: true });
        window.addEventListener('resize', this.queueFit, { signal: this.abort.signal });
        document.fonts.addEventListener('loadingdone', this.queueFit, { signal: this.abort.signal });
        document.fonts.ready.then(() => { if (this.isConnected) this.queueFit(); });
        this.queueFit();
      }
      fitText() {
        if (!this.isConnected || this.clientWidth === 0) return;
        this.style.removeProperty('--csb-heading-fit');
        this.style.removeProperty('--csb-subtext-fit');
        let groupWidth = 0;
        for (const item of this.querySelectorAll('.csb-item')) {
          const style = getComputedStyle(item);
          const textWidths = [...item.querySelectorAll('.csb-heading span, .csb-subtext span')]
            .filter(span => getComputedStyle(span).display !== 'none')
            .map(span => span.getBoundingClientRect().width);
          const width = Math.ceil(Math.max(0, ...textWidths) + parseFloat(style.paddingLeft) + parseFloat(style.paddingRight) + 2);
          item.style.setProperty('--csb-item-width', `${width}px`);
          groupWidth += width;
        }
        this.style.setProperty('--csb-natural-width', `${groupWidth}px`);
        for (const kind of ['heading', 'subtext']) {
          const rows = [...this.querySelectorAll(`[data-csb-${kind}]`)];
          let scale = 1;
          for (const row of rows) {
            const text = [...row.children].find(span => getComputedStyle(span).display !== 'none');
            if (text && text.getBoundingClientRect().width > 0) {
              scale = Math.min(scale, Math.max(1, row.clientWidth - 2) / text.getBoundingClientRect().width);
            }
          }
          if (rows.length && scale < 1) {
            const size = parseFloat(getComputedStyle(rows[0]).fontSize);
            this.style.setProperty(`--csb-${kind}-fit`, `${Math.floor(size * scale * 10) / 10}px`);
          }
        }
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.abort?.abort();
        this.resizeObserver?.disconnect();
        this.contentObserver?.disconnect();
        this.lastWidth = undefined;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
